import InstallPromptService from '@/services/install-prompt';

window.addEventListener('beforeinstallprompt', ((event: BeforeInstallPromptEvent) => {
  event.preventDefault();

  InstallPromptService.updateDeferred(event);
}) as (e: Event) => void);

window.addEventListener('appinstalled', () => {
  InstallPromptService.updateInstalled(true);
  InstallPromptService.updateDeferred(null);
});
